import axios from 'axios';

const KEY = 'oj7fp6P8mXas8zNN99jJU2FwE3QW26104hsA7okr';

export default axios.create(
  {
      baseURL: 'https://hyj6umtyma.execute-api.eu-west-1.amazonaws.com/Stage',
      headers: {
          'X-Api-Key':  KEY,
          'Content-Type': 'application/json'
        },
      crossDomain: true
  }
); 
